import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Row, Col } from 'antd';
import { Container, Title, GoBack } from 'src/components';
import FilterComponent from './filters/FilterComponent';
import { ChartFilter } from './filters/filter-type';
import { IReduxState } from 'src/store';
import { IPatrimony } from 'src/interfaces/patrimony';
import { ITechnician } from 'src/interfaces/technician';
import { IOperator } from 'src/interfaces/operator';

const today = new Date();
const endDate = today.toISOString().slice(0, 10);

const startDateObj = new Date(today);
startDateObj.setDate(startDateObj.getDate() - 8);
const startDate = startDateObj.toISOString().slice(0, 10);

export default function TaskChartPage() {
  const [filters, setFilters] = useState<ChartFilter>({
    startDate: startDate,
    endDate: endDate,
    periodType: 'occurredAt',
    groupBy: 'cell',
  });

  const sectors = useSelector(
    (state: IReduxState) =>
      state.sectors.all?.map((s) => ({
        label: s.name || 'Não informado',
        value: s.id,
      })) || []
  );

  const cells = useSelector(
    (state: IReduxState) =>
      state.cells.all?.map((c) => ({ label: c.name, value: c.id })) || []
  );

  const patrimonies = useSelector(
    (state: IReduxState) =>
      state.patrimonies.all?.map((p: IPatrimony) => ({
        label: p.number || 'Não informado',
        value: p.id,
      })) || []
  );

  const technicians = useSelector(
    (state: IReduxState) =>
      state.technicians.all?.map((t: ITechnician) => ({
        label: t.name,
        value: t.id,
      })) || []
  );

  const operators = useSelector(
    (state: IReduxState) => {
      if (!state.operators.all) return [];
      if (state.operators.all.length && (state.operators.all[0] as any).label && (state.operators.all[0] as any).value) {
        return state.operators.all as {label: string, value: number}[];
      }
      return (state.operators.all as IOperator[]).map((o) => ({ label: o.name, value: o.id }));
    }
  );

  return (
    <Container type="fluid">
      <Row gutter={16} className="mt-2" align="middle" justify="space-between">
        <Col>
          <GoBack color="#444" />
          <Title
            foreword="Relatórios"
            title="Relatórios"
            subtitle="Relatórios para OS."
          />
        </Col>
      </Row>

      <FilterComponent
        filters={filters}
        onChange={setFilters}
        sectors={sectors}
        cells={cells}
        patrimonies={patrimonies}
        technicians={technicians}
        operators={operators}
      />
    </Container>
  );
}
